import { CREATE_INSTAGRAM_POST_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function instaPosts(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case CREATE_INSTAGRAM_POST_SUCCESS:
      
      const parsedData = JSON.parse(action.payload.data)
      return { ...state, posts: parsedData, errors: null }
    default:
      return state;
  }
}